/**
 * A search-result tile as the live stream last saw it (T07-40, R21) — pure, so it is tested
 * without rendering: a change newer than the list's read replaces the availability at once.
 */
import { isOneOfAKind } from "@/features/offline/useOfflineRules";
import type { AvailabilityStore } from "@/realtime/availability";

import type { TileItem } from "./ResultTile";

export interface LiveTile {
  item: TileItem;
  /** The stream said it went away at this time (ISO) — the red bar "hh:mmに売れました". */
  goneAt: string | null;
  /** One-of-a-kind card while the stream is down / the list is being re-read (T07-40). */
  checking: boolean;
}

/**
 * A tile as the stream last saw it (T07-40): a change newer than the list's read replaces the
 * availability at once (sold on the web / held at another register → the button closes).
 */
export function liveTile(
  item: TileItem,
  store: Pick<AvailabilityStore, "get">,
  readAt: number,
  checking: boolean,
  inBasket: ReadonlySet<string> = new Set(),
): LiveTile {
  const change = store.get(item.variantId, readAt);
  // our own basket holds it: "reserved" is us, not a sale elsewhere
  const ours = change?.reason === "reserved" && inBasket.has(item.variantId);
  const next: TileItem = change
    ? {
        ...item,
        available: change.available,
        quantity: change.quantity,
        reason: ours ? "in_basket" : change.reason,
      }
    : item;
  return {
    item: next,
    goneAt: change && !change.available && !ours ? change.at : null,
    checking: checking && next.available && isOneOfAKind(next.productType),
  };
}
